module.exports = __webpack_public_path__ + "static/media/magnifying-glass.a87eca9e.svg";